import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const passwordResetConfirm = async (email, password) => {
  const ROUTE = urlConfig.backend.routes.authentication.passwordResetConfirm;
  const url = `${BACKEND_URL}${ROUTE}`;
  const reqData = { email, password };

  return await axios
    .post(url, reqData)
    .then((res) => {
      if (res.status === 200) {
        return { error_code: 1, res: res.data };
      }
      return {
        error_code: 2,
        error_message: "Unable to reset password.",
      };
    })
    .catch((error) => {
      return {
        error_code: 2,
        error_message:
          error?.response?.data?.message ||
          error?.response?.data?.detail ||
          "Password reset failed.",
      };
    });
};
